window.ngLandingPagesUtils = {};

var handleRequestDemoClick = function (dataResolver) {

    var $stateParams = $injector.get('$stateParams');
    var $httpParamSerializer = $injector.get('$httpParamSerializer');
    var data = dataResolver();

    var types = {
        'demo_request': {
            title: $filter('translate')('Discover Harri'),
            formTypeLabel: 'Request Demo'
        },
        'contact_sales': {
            title: $filter('translate')('Contact Sales'),
            formTypeLabel: 'Contact Sales'
        }
    };

    var withoutUnderscore = function (value) {
        if(!value) {
            return value;
        }
        return value.split('_').join(' ');
    };

    var info = types[data.type] || types.demo_request;


    var utmTrackingData = {
        user_location: data.pageVersion,
        utm_campaign: withoutUnderscore($stateParams.utm_campaign),
        utm_content: withoutUnderscore($stateParams.utm_content),
        utm_medium: withoutUnderscore($stateParams.utm_medium),
        utm_source: withoutUnderscore($stateParams.utm_source),
        utm_term: withoutUnderscore($stateParams.utm_term),
        Referrer_link: window.location.pathname,
        type: info.formTypeLabel
    };

    var formLink = 'https://solutions.harri.com/get-demo';
    var url = formLink + '?' + $httpParamSerializer(utmTrackingData);
    window.open(url, '_blank').focus();

};


ngLandingPagesUtils.handleRequestDemoClick = handleRequestDemoClick;

Object.freeze(ngLandingPagesUtils);
